import { createFileRoute } from "@tanstack/react-router";
import { OpportunityInbox } from "@/features/opportunities/opportunity-inbox";
import { opportunitySearchSchema } from "@/features/opportunities/search-schema";

export const Route = createFileRoute("/_authenticated/$store/opportunities/")({
  validateSearch: opportunitySearchSchema,
  head: () => ({ meta: [{ title: "Opportunities · Rogue AI" }] }),
  component: OpportunityInbox,
});
